import { render, staticRenderFns } from "./cabinet-documents-list.vue?vue&type=template&id=61ab1d0e&scoped=true"
import script from "./cabinet-documents-list.vue?vue&type=script&lang=js"
export * from "./cabinet-documents-list.vue?vue&type=script&lang=js"
import style0 from "./cabinet-documents-list.vue?vue&type=style&index=0&id=61ab1d0e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ab1d0e",
  null
  
)

export default component.exports